import React from "react";
import AuditorForm from "./AuditorForm";

export default function AuditorCreatePage() {
  return <AuditorForm isEditMode={false} />;
}
